<template>
  <div :class="classes" :style="style">
    <i
      class="operate el-icon-close"
      title="关闭"
      @mousemove.stop
      @click="$emit('close')"
      style="z-index:1000"
    ></i>
    <slot></slot>
  </div>
</template>

<script>
import _ from 'lodash';

const defaultLeft = 500;
const defaultTop = 500;
const defaultRight = 500;
const defaultBottom = 500;

export default {
  props: [
    'width',
    'height',
    'top',
    'left',
    'right',
    'bottom',
    'className',
    'name',
    'day'
  ],
  computed: {
    classes() {
      return 'bf-panel ' + this.className;
    },
    style() {
      let x = this.formatUnitToPx(this.left, 'x'),
        y = this.formatUnitToPx(this.top, 'y'),
        width = this.formatUnitToPx(this.width, 'x'),
        height = this.formatUnitToPx(this.height, 'y');
      const existLeft = _.isEmpty(x);
      const existRight = _.isEmpty(y);
      const existWidth = _.isEmpty(width);
      const existHeight = _.isEmpty(height);
      const existBottom = _.isEmpty(this.bottom);
      const existTop = _.isEmpty(this.top);

      const computedTop = existTop
        ? this.formatUnitToPx(this.top, 'y')
        : defaultTop;
      const computedBottom = existBottom
        ? this.formatUnitToPx(this.bottom, 'y')
        : defaultBottom;
      const computedLeft = existLeft
        ? this.formatUnitToPx(this.left, 'x')
        : defaultLeft;
      const computedRight = existRight
        ? this.formatUnitToPx(this.right, 'x')
        : defaultRight;
      // const computedWidth = existWidth ? this.width : defaultWidth
      // const computedHeight = existHeight ? this.height : defaultHeight

      if (!existLeft) {
        x = document.body.clientWidth - computedRight - width;
      }

      if (!existRight) {
        y = document.body.clientHeight - computedBottom - height;
      }

      if (!existWidth) {
        width = document.body.clientWidth - computedLeft - computedRight;
      }

      if (!existHeight) {
        height = document.body.clientHeight - computedTop - computedBottom;
      }
      return {
        width: width + 'px',
        height: height + 'px',
        transform: `translate(${x}px,${y}px)`
      };
    }
  },
  methods: {
    /**
     * direc: x or y 标志尺寸的轴向
     */
    formatUnitToPx(val, direc) {
      if (_.isString(val)) {
        let PxSize;
        if (/vw/.test(val)) {
          PxSize = document.body.clientWidth;
        } else if (/vh/.test(val)) {
          PxSize = document.body.clientHeight;
        } else if (direc === 'x') {
          PxSize = document.body.clientWidth;
        } else if (direc === 'y') {
          PxSize = document.body.clientHeight;
        }

        if (val === 'center') {
          return this.resolveCenterToPx(val, direc);
        }

        if (/%|vh|vw/.test(val)) {
          return (parseInt(val) / 100) * PxSize;
        }
      }
      return val;
    },
    resolveCenterToPx(val, direc) {
      if (direc === 'x') {
        const width = this.formatUnitToPx(this.width, direc);
        const left = (document.body.clientWidth - width) / 2;
        return left;
      } else if (direc === 'y') {
        const height = this.formatUnitToPx(this.height, direc);
        const top = (document.body.clientHeight - height) / 2;
        return top;
      }
    }
  }
};
</script>

<style lang="scss">
.bf-panel {
  position: absolute;
  top: 0;
  left: 0;
  transition: none;
  z-index: 9999;
  border: 1px solid #249fea;
  .operate {
    float: right;
    cursor: pointer;
    padding: 3px;
    transition: transform 0.3s;
    transform: rotate(0);
    border-radius: 100%;
    color: white;
    font-size: 1.4em;
    &:hover {
      transform: rotate(90deg);
      background-color: #15568e;
      color: #08ffce;
    }
  }
  .operate {
    position: absolute;
    right: 10px;
    top: 10px;
  }
  background-color: rgba(9, 35, 53, 0.9);
}
</style>
